export default __webpack_public_path__ + "static/media/digital_account_card.3ca5a922.png";